var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 172.253,
    viewBox: "0 0 240 172.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(-572 -1954.874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 240,
    height: 135,
    rx: 42,
    transform: "translate(572 1992.126)",
    fill: "#f5fafd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "language",
    transform: "translate(612.799 1954.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(35.755 40.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M125.767,137h-1.908l-3.566,17.834h9.04Z",
    transform: "translate(-120.293 -137)",
    fill: "#4397d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(113.355 76.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M381.374,257a46.593,46.593,0,0,0,7.32,12.92A47.062,47.062,0,0,0,396.31,257Z",
    transform: "translate(-381.374 -257)",
    fill: "#4397d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(72.126 27.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M309.342,91H253.974l11.545,92.64a13.84,13.84,0,0,1-3.3,10.149l-19.551,22.344h66.68a13.39,13.39,0,0,0,13.375-13.375V104.673A13.647,13.647,0,0,0,309.342,91Zm0,49.34h-1.191a56.573,56.573,0,0,1-10.741,19.529c3.275,2.994,6.777,5.451,10.259,8.2a4.457,4.457,0,0,1-5.573,6.958c-3.783-2.986-7.335-5.486-10.886-8.745-3.551,3.259-6.805,5.759-10.589,8.745a4.457,4.457,0,0,1-5.573-6.958c3.482-2.751,6.687-5.207,9.962-8.2a56.273,56.273,0,0,1-10.443-19.529h-1.191a4.458,4.458,0,1,1,0-8.917h13.375v-4.458a4.458,4.458,0,0,1,8.917,0v4.458h13.673a4.458,4.458,0,0,1,0,8.917Z",
    transform: "translate(-242.663 -91)",
    fill: "#4397d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M72.573,11.716A13.393,13.393,0,0,0,59.3,0H13.375A13.39,13.39,0,0,0,0,13.375v98.68a13.39,13.39,0,0,0,13.375,13.375h70.31c1.3-1.487,2.391-2.418,2.437-4.358C86.133,120.586,72.633,12.2,72.573,11.716Zm-17.9,73.5a4.457,4.457,0,0,1-5.246-3.5l-2.85-14.25H33.972l-2.85,14.25a4.458,4.458,0,1,1-8.743-1.75L31.3,35.387A4.461,4.461,0,0,1,35.667,31.8h9.214a4.461,4.461,0,0,1,4.371,3.583L58.17,79.971A4.458,4.458,0,0,1,54.674,85.218Z",
    fill: "#4397d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(52.093 134.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M175.261,452l.765,6.117a13.483,13.483,0,0,0,7.71,10.36L198.7,452Z",
    transform: "translate(-175.261 -452)",
    fill: "#4397d2"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.beb056020587f01398eb4111bec6265b.svg";
export { ForwardRef as ReactComponent };